import { useAuth } from "@/hooks/useAuth"
import { Link } from "react-router-dom";
import { Button } from "../ui/button";



export const SaveResultMessage = () => {
    const { isAuth, loading } = useAuth();

    if (!loading && isAuth) return null;

    return (
        <div className="bg-card bg-olive-50 border rounded-lg p-6 mt-8 mb-8">
            <h3 className="text-center">Чтобы сохранить результат теста, вы должны авторизоваться</h3>
            <div className="flex justify-center">
                <Link to="/auth" className="bg-olive-50 text-olive-800 duration-300 hover:scale-105 border rounded-2xl hover:text-olive-900 hover:bg-olive-700">
                    <Button>Авторизоваться</Button>
                </Link>
            </div>
        </div>
    )
}